import React from "react";
import {TicTacEncabezado3,TicTacParafh,TictacDivBlock,TicTacTable,
  TicTacView,TicTacCode
} from "../FormasTicTac";



export function TictacOther2( {titulo,lasttitle,epigrafe,parrafo,tabla,cuerpo,code,code2,view} ){
  return (
    <>
      <TicTacEncabezado3 title={titulo[0]} subtitle={lasttitle[0]} epigraph={epigrafe[0]}/>
      <TicTacParafh parafh={parrafo[0]}/>
      <TictacDivBlock capture={view[0]} parafh={parrafo[1]}/>
      <TicTacTable tabla={tabla} cuerpo={cuerpo} />
      <TicTacParafh parafh={parrafo[2]}/>
      <TictacDivBlock capture={view[1]} parafh={parrafo[3]}/>
      <TicTacView capture={view[2]}/>
      <TicTacParafh parafh={parrafo[4]}/>
      <TictacDivBlock capture={view[3]} parafh={parrafo[5]}/>
      <TicTacView capture={view[4]}/>
      <TicTacCode code={code}/>
      <TicTacView capture={view[5]}/>
      <TicTacCode code={code2}/>
      <TictacDivBlock capture={view[6]} parafh={parrafo[6]}/>
      <TicTacView capture={view[7]}/>
      <TicTacEncabezado3 title={titulo[1]} subtitle={lasttitle[1]} epigraph={epigrafe[1]}/>
      <br/>
    </>
  );
}
